export const GlobalSearchType = {
  BRAND: 1,
  CATEGORY: 2,
  PRODUCT: 3
};